<template>
  <div class="plotly-chart">
    <div ref="chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist";

export default {
  name: "PlotlyChart",
  props: {
    labels: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "line", // line, bar, pie, donut
    },
    title: {
      type: String,
      default: "Grafik",
    },
  },
  watch: {
    // Eğer props değişirse grafiği yeniden çiz
    labels: "renderChart",
    data: "renderChart",
    type: "renderChart",
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      let trace;
      let layout;

      switch (this.type) {
        case "line":
          trace = {
            x: this.labels,
            y: this.data,
            mode: "lines+markers",
            type: "scatter",
            line: { color: "royalblue", width: 3 },
            marker: { size: 8,
                color: [
          'rgba(255,99,132,0.7)',   // Ocak
          'rgba(54,162,235,0.7)',   // Şubat
          'rgba(255,206,86,0.7)',   // Mart
          'rgba(75,192,192,0.7)',   // Nisan
          'rgba(153,102,255,0.7)'   // Mayıs
        ],

             },
            name: this.title,
          };
          layout = {
            title: this.title + " (Çizgi Grafik)",
            xaxis: { title: "Etiketler" },
            yaxis: { title: "Değerler" },
          };
          break;

        case "bar":
          trace = {
            x: this.labels,
            y: this.data,
            type: "bar",
            marker: {         color: [
          'rgba(255,99,132,0.7)',   // Ocak
          'rgba(54,162,235,0.7)',   // Şubat
          'rgba(255,206,86,0.7)',   // Mart
          'rgba(75,192,192,0.7)',   // Nisan
          'rgba(153,102,255,0.7)'   // Mayıs
        ],
 },
            name: this.title,
          };
          layout = {
            title: this.title + " (Çubuk Grafik)",
            xaxis: { title: "Etiketler" },
            yaxis: { title: "Değerler" },
          };
          break;

        case "pie":
          trace = {
            labels: this.labels,
            values: this.data,
            type: "pie",
            textinfo: "label+percent",
          };
          layout = {
            title: this.title + " (Pasta Grafik)",
          };
          break;

        case "donut":
          trace = {
            labels: this.labels,
            values: this.data,
            type: "pie",
            hole: 0.4,
            textinfo: "label+percent",
          };
          layout = {
            title: this.title + " (Halka Grafik)",
          };
          break;

        default:
          console.warn("Desteklenmeyen grafik türü:", this.type);
          return;
      }

      Plotly.newPlot(this.$refs.chart, [trace], layout, { responsive: true });
    },
  },
};
</script>

<style scoped>
.plotly-chart {
  width: 100%;
  max-width: 600px;
  margin: auto;
}
</style>
